// External libraries
import gql from 'graphql-tag';

// Internal modules
import { NORMALIZED_ADDRESSES_FRAGMENT } from '../fragments/normalizedAddresses.gql';

export const NORMALIZED_ADDRESSES_QUERY = gql`
  ${NORMALIZED_ADDRESSES_FRAGMENT}
  query GetNormalizedAddressesQuery(
    $shippingcity: String
    $shippingcountry: CountryCodes
    $shippingline1: String
    $shippingline2: String
    $shippingpostalCode: String
    $shippingstate: String
    $billingcity: String
    $billingcountry: CountryCodes
    $billingline1: String
    $billingline2: String
    $billingpostalCode: String
    $billingstate: String
    $token: String!
    $transliterationType: AddressNormalizationTransliterationType
  ) {
    shippingAddress: addressNormalization(
      city: $shippingcity
      country: $shippingcountry
      line1: $shippingline1
      line2: $shippingline2
      postalCode: $shippingpostalCode
      state: $shippingstate
      token: $token
      transliterationType: $transliterationType
    ) {
      ...AddressNormalizationFragment
    }
    billingAddress: addressNormalization(
      city: $billingcity
      country: $billingcountry
      line1: $billingline1
      line2: $billingline2
      postalCode: $billingpostalCode
      state: $billingstate
      token: $token
      transliterationType: $transliterationType
    ) {
      ...AddressNormalizationFragment
    }
  }
`;
